export enum PriceSkus {
  TerminalAnnual = 'terminal_annual',
  TerminalMonthly = 'terminal_monthly',
  TerminalAnnual2024 = 'terminal_annual_2024',
}
